import { Alert } from "@mui/material";
import { useParams, useSearchParams } from "react-router-dom";
import DocViewer from "src/components/DocViewer";
import { PageBreadcrumb } from "src/components/PageBreadcrumb";
import { PageHeader } from "src/components/PageHeader/PageHeader";
import { ROUTES, ROUTE_SLUGS } from "src/config/navigation/routes";
import { useGetTrashedDocument } from "src/hooks/queries";
import { fillRouteWithSlugs } from "src/utils/navigation";

export const TrashDocumentViewerPage = () => {
  const { docId = "", orgId = "" } = useParams<{
    docId: string;
    orgId: string;
  }>();
  const [searchParams] = useSearchParams();
  const {
    data: document,
    isError,
    isLoading,
  } = useGetTrashedDocument(orgId, docId);
  const versionId = searchParams.get("v");
  const selectedVersion =
    document?.versions.find((version) => version.id === versionId) ??
    document?.versions[0];
  const documentsRoute = fillRouteWithSlugs(ROUTES.DOCUMENTS, {
    [ROUTE_SLUGS.ORG_ID]: orgId,
  });

  return (
    <div
      className="flex h-full min-h-0 flex-1 flex-col p-0"
      data-testid="trash-document-viewer-page"
    >
      <PageHeader
        pageTitleComponent={
          <PageBreadcrumb
            isLoading={isLoading}
            items={[
              { label: "Documents", to: `${documentsRoute}?view=trash` },
              { label: document?.title ?? "Deleted document" },
            ]}
          />
        }
      />

      <div className="flex min-h-0 flex-1 justify-center">
        {isError && !document ? (
          <Alert severity="error" sx={{ alignSelf: "flex-start", m: 3 }}>
            Could not load this deleted document. It may have been restored or
            permanently deleted.
          </Alert>
        ) : (
          <DocViewer
            deviceId={document?.deviceId ?? ""}
            docId={docId}
            documentWithAllVersions={document}
            documents={document ? [document] : undefined}
            docProgress={undefined}
            isLoading={isLoading}
            selectedDocVersion={selectedVersion}
          />
        )}
      </div>
    </div>
  );
};

export default TrashDocumentViewerPage;
